import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FournisseurDTO } from '../../customs/_models/FournisseurDTO';
import { emplacementDTO } from '../../customs/_models/emplacementDto';
import { ProduitStockDTO } from '../../customs/_models/ProduitStockDTO';

@Injectable({
  providedIn: 'root'
})
export class ProduitStocktService {

  private apiUrl = environment.base_url + '/api/prdStock';
  private apiUrl1 = environment.base_url + '/documents';
  constructor(private http: HttpClient) {}

  // 🔹 Créer un nouveau fournisseur
createProduit(formData: FormData): Observable<any> {
  return this.http.post(`${this.apiUrl}`, formData);
}
getDocumentUrl(filePath: string): string {
  return `${this.apiUrl1}/${encodeURI(filePath)}`;
}

uploadDocument(produitId: number, formData: FormData): Observable<any> {
  return this.http.post(`${this.apiUrl}/${produitId}/upload-document`, formData);
  }
  // 🔹 Modifier un fournisseur existant
updateProduit(id: number, produitFormData: FormData): Observable<ProduitStockDTO> {
  return this.http.put<ProduitStockDTO>(`${this.apiUrl}/${id}`, produitFormData);
}

deleteFile(productId: number, filePath: string): Observable<any> {
  const params = new HttpParams()
    .set('productId', productId.toString())
    .set('path', filePath);
  return this.http.delete(`${this.apiUrl1}/delete`, { params });
}


  // 🔹 Récupérer tous les fournisseurs (avec flag = true côté backend)
  getAllProducts(): Observable<ProduitStockDTO[]> {
    return this.http.get<ProduitStockDTO[]>(this.apiUrl);
  }

  // 🔹 Récupérer un fournisseur par son ID
  getProcutById(id: number): Observable<ProduitStockDTO> {
    return this.http.get<ProduitStockDTO>(`${this.apiUrl}/${id}`);
  }

  // 🔹 Suppression logique (soft delete)
  deleteProuct(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
